import { selectActiveLayer, selectAttributeQueryParams, selectDrawGeometry, selectExtentGeometry, selectMap, selectSelectedFeatureId, selectSelectedFilter, } from '../../../../selectors/insightSelectors'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { setSelectedFeatureId, } from '../../../../state/insightSlice';
import { GenericFeatureTable } from '@trcsolutions/springboard-ui';
import { baseInstance } from 'axios/instances';


const FeatureTable = () => {
    const dispatch = useAppDispatch()
    const map = useAppSelector(selectMap)
    const activeLayer = useAppSelector(selectActiveLayer)
    const drawGeometry = useAppSelector(selectDrawGeometry)
    const selectedFeatureId = useAppSelector(selectSelectedFeatureId)
    const attributeQueryParams = useAppSelector(selectAttributeQueryParams)
    const extentGeometry = useAppSelector(selectExtentGeometry)
    const selectedFilter = useAppSelector(selectSelectedFilter)

    const handleRowSelectionChange = (objectId: string) => {
        dispatch(setSelectedFeatureId(objectId))
    }

    return (
      <GenericFeatureTable
        baseInstance={baseInstance}
        activeLayer={activeLayer}
        map={map}
        selectedFeatureId={selectedFeatureId}
        attributeQueryParams={attributeQueryParams}
        drawGeometry={drawGeometry}
        handleRowSelectionChange={handleRowSelectionChange}
        extentGeometry={extentGeometry}
        selectedFilter={selectedFilter}
        enableCellTextSelection={true}
      />
    );
}

export default FeatureTable